<template>
  <div class="scroll-box" ref="staffScrollbar">
    <div class="chat-complate" v-if="pageInfo.totals == 0 && !loading" style="height:100%;">
      <span class="empty-text">暂无数据</span>
    </div>
    <!-- 存储新版本和绘话存档组件 -->
    <div id="new-conversation-iframe-container" v-loading="loading" element-loading-text="拼命加载中..."></div>
  </div>
</template>
<script>
import {
  register,
  initOpenData,
  createOpenDataFrameFactory,
  createScrollViewContext,
} from "@/utils/wecom.cjs.js"; // 企微的api，目前npm下载和cdn引入都会出现api不全的情况，只能通过将包下载到本地进行应用，后续企微如修复可以使用其他方式（2024.06.14）
import sha1 from "sha1";//签名加密
import { getAgentConfig } from "../../../utils/common";//注入应用的权限
import { getFileSessionKey } from "../../../api/staff/staff.js";
import { getCustomerChatMsg } from "../../../api/customer/customer.js";

let that;//存放vue的this，供调用企微内函数时使用
export default {
  props: {
    // 外部好友id
    idData: {
      type: Array,
      default: [],
      required: true
    },
    //聊天类型（区分公共组件调用不同类型）员工-客户：employees 客户-员工：customer
    chatType: {
      type: String,
      default: 'employees',
      required: true
    },
  },

  data() {
    return {
      // 加载
      loading: false,
      // 消息内容
      msgList: [],
      // 展示组件实例
      instance: null,
      // 对话人和交流人数据
      sendInfo: {
        sendFrom: "",
        sendTo: ""
      },
      // 分页详情
      pageInfo: {
        size: 20,
        current: 1,
        totals: 0,
      },
      loadMore: false,
      // 内容类型
      msgType: '',
      // 提示实例，防止弹出多个提示
      messageInstance: null
    };
  },

  methods: {
    /** 获取聊天数据 */
    getDataList() {
      console.log("士大夫士大夫但是时段",this.chatType);
      this.$emit("requestSuccess", false)
      this.loading = true;
      // 员工-客户列表会话组件-employees
      if (this.chatType === 'employees') {
        getFileSessionKey(this.sendInfo.sendFrom, this.sendInfo.sendTo, this.pageInfo.current, this.pageInfo.size, localStorage.getItem("Authorization"), true, this.msgType).then((res) => {
          if (res && res.error && res.error.code === 200) {
            console.log("res.data?.totals", res.data?.totals);
            this.pageInfo.totals = res.data?.totals
            if (!(that.msgList.length >= res.data?.totals)) {
              this.msgList = this.msgList.concat(res.data?.result || [])
              if (this.msgList.length < res.data?.totals) {
                if (that.instance) {
                  that.instance.setData({
                    tip: "加载更多...",
                    totals: this.pageInfo.totals
                  })
                }
              } else {
                if (that.instance) {
                  that.instance.setData({
                    tip: "没有更多数据了",
                    totals: this.pageInfo.totals
                  })
                }
              }
              that.instance.setData({
                msgList: this.msgList
              })
            } else {
              console.log("有没有进来");
              if (that.instance) {
                that.instance.setData({
                  tip: "没有更多数据了",
                  totals: this.pageInfo.totals
                })
              }
            }
          } else {
            if (this.messageInstance) this.messageInstance.close()
            this.messageInstance = this.$message("获取失败，请稍后再试")
          }
          this.$emit("requestSuccess", true)
          this.loading = false;
        }).catch((err) => {
          if (this.messageInstance) this.messageInstance.close()
          this.messageInstance = this.$message("获取失败，请稍后再试")
          this.$emit("requestSuccess", true)
          this.loading = false;
          console.log(err, "errr");
        });
      } else if(this.chatType === 'customer'){
        // 客户-员工列表会话组件：customer
        getCustomerChatMsg(this.sendInfo.sendFrom, this.sendInfo.sendTo, this.pageInfo.current, this.pageInfo.size, localStorage.getItem("Authorization"), this.msgType).then((res) => {
          if (res && res.error && res.error.code === 200) {
            this.pageInfo.totals = res.data?.totals
            if (!(that.msgList.length >= res.data?.totals)) {
              this.msgList = this.msgList.concat(res.data?.result || [])
              if (this.msgList.length < res.data?.totals) {
                if (that.instance) {
                  that.instance.setData({
                    tip: "加载更多..."
                  })
                }
              } else {
                if (that.instance) {
                  that.instance.setData({
                    tip: "没有更多数据了",
                    totals: this.pageInfo.totals
                  })
                }
              }
              that.instance.setData({
                msgList: this.msgList
              })
            } else {
              if (that.instance) {
                that.instance.setData({
                  tip: "没有更多数据了",
                  totals: this.pageInfo.totals
                })
              }
            }
          } else {
            this.$message.error("获取失败,请稍后再试")
          }
          this.$emit("requestSuccess", true)
          this.loading = false;
        }).catch((err) => {
          this.loading = false;
          this.$emit("requestSuccess", true)
          this.$message.error("获取失败,请稍后再试")
          console.log(err, "errr");
        });
      }else if(this.chatType === 'group'){
        console.log("群群群");
      }

    },

    /** 注册应用信息 */
    async registerInformation() {
      let enterpriseData = JSON.parse(
        window.localStorage.getItem("enterpriseData")
      );
      // 初始化应用信息
      register({
        corpId: enterpriseData.corpid,
        agentId: enterpriseData.agentid,
        jsApiList: [
          "selectExternalContact",
          "shareAppMessage",
          "wwapp.invokeJsApiByCallInfo",
        ],
        getAgentConfigSignature: async (url) => {
          console.log("dfssdfdsfsd", url);
          let timestamp = Date.parse(new Date()) / 1000;
          let nonceStr = this.randomString(17);
          let signature = sha1(
            `jsapi_ticket=${enterpriseData.ticket}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${url}`
          );
          return { timestamp, nonceStr, signature };
        },
        onAgentConfigSuccess:(res)=>{
            console.log("res++++++++++",res);
        },
        onAgentConfigFail:(res)=>{
          this.$message.error("初始化失败，请稍后再试")
            console.log("res1++++++++++",res);
        }
      });
      // 会话组件需要确保 WWOpenData 初始化成功
      await initOpenData();
      // 
      this.getComponents();
    },

    /** 获取展示组件工厂对象 */
    async getComponents() {
      // 创建“展示组件工厂”对象备用：
      this.factory = await createOpenDataFrameFactory();
      this.getSessioInstance();
    },

    /** 生成会话组件实例 */
    async getSessioInstance() {
      this.instance = await this.factory.createOpenDataFrame({
        // “容器”元素，用于挂载展示组件
        el: "#new-conversation-iframe-container",
        // html 
        template: `
          <scroll-view  
           class="scroll-wrap" 
           scroll-y
           ref="scrollRef" 
           lower-threshold={{0}}
           scroll-top="{{data.scrollTop}}"
           bindscrolltolower="onScrollLower" >
            <view class="list" >
              <view
                wx:for="{{data.msgList}}"
                wx:key="msgid"
                class="msg"
                data-index="{{index}}" >
                <!-- 好友 -->
                <view class="chat-item-orther" wx:if={{!item.mineMsg}}>
                  <view class="message-info">
                     <ww-open-data type="externalUserName"  class="user-name" openid="{{item.userId}}"/>
                     <view class="date-wrap">{{item.dateStr}}</view>  
                  </view>
                  <view class="content">
                    <ww-open-data type="externalUserAvatar"  class="user-avatar" openid="{{item.userId}}"/> 
              <view class="info-record left {{item.hitMsg?'crux':''}}">
              <ww-suspense>
              <ww-open-message
                class="message-content"
                message-id="{{item.msgid}}"
                secret-key="{{item.encrypted_secret_key}}"
                binderror="onOpenMsgError"
                open-type="viewMessage"/> 
               <block wx:slot="fallback">
                  <view class="msgCnt-fallback">消息内容正在加载...</view>
               </block>
                </ww-suspense> 
              </view>
            </view>
          </view>
  
          <!-- 员工 -->
          <view class="chat-item-self" wx:else>
          <view class="message-info-self">
            <view class="date-wrap">
              {{item.dateStr}}
            </view>  
            <ww-open-data type="userName"  class="user-name-my" openid="{{item.staffUserId}}"/>
          </view>
          <view class="content-self">
            <view class="info-record right"  >
              <ww-suspense>
              <ww-open-message
              class="message-content-self"
              message-id="{{item.msgid}}"
              secret-key="{{item.encrypted_secret_key}}"
              open-type="viewMessage"/> 
              <block wx:slot="fallback">
                  <view class="msgCnt-fallback">消息内容正在加载...</view>
               </block>
                </ww-suspense> 
              </view>
              <ww-open-data type="userAvatar"  class="user-avatar" openid="{{item.staffUserId}}"/> 
          </view>
        </view>
         </view>
         <view class="more-tip" wx:if={{data.totals!=0}}>{{data.tip}}</view>
        </view>
      </scroll-view>
    `,
        // css
        style: `
          .chat-item-orther{
              margin-bottom:10px
          }
          .chat-item-self{
            margin-bottom:10px
          }
          .message-info{
              font-size: 12px;
              color: #9098aa;
              margin: 0;
              display: flex;
              line-height: 20px;
              margin-top: -5px;
              text-align: left;
              margin-left: 52px;
          }
          .user-name{
            margin-right:4px
          }
       .msg {
        width:100%;
      }
      .content{
        display: flex;
        align-items: center;
      }
  
      .content-self{
        display: flex;
        align-items: center;
        justify-content:flex-end;
      }
  
      .user-avatar {
         margin-right: 10px;
         width: 40px;
         height: 40px;
         border-radius: 50%;
         flex-shrink: 0;
         display: flex;
         align-items: center;
         justify-content: center;
         background-color: #ccc;
     }
  
     .message-info{
        display:flex;
        justify-content:flex-start;
        align-items: center;
        height:100%;
     }
  
     .message-info-self{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height:100%;
        font-size: 12px;
        color: #9098aa;
        margin: 0;
        isplay: flex;
        line-height: 20px;
        margin-top: -5px;
        text-align: left;
        margin-right: 52px;
     }

     .user-name-my{
      margin-left:4px
     }

     .info-record{
        font-size: 14px;
        padding: 7px 10px;
        border-radius: 6px;
        position: relative;
        margin-top: 5px;
     }
  
     .left {
          background: #dee0e3;
           &::before {
              position: absolute;
              left: -8px;
              top: 50%;
              transform: translate(0, -50%);
              content: "";
              border-right: 10px solid #dee0e3;
              border-top: 8px solid transparent;
              border-bottom: 8px solid transparent;
           }
      }
            .crux {
            background: #99ff66;
             &::after {
               position: absolute;
              left: -8px;
              top: 50%;
              transform: translate(0, -50%);
              content: "";
              border-right: 10px solid #99ff66;
              border-top: 8px solid transparent;
              border-bottom: 8px solid transparent;
          }

      }

      .right {
          top: 0;
          right: 0;
          margin-right: 10px;
          background: #C9E7FF;
          text-align: left;
           &::after {
             position: absolute;
              right: -8px;
              top: 50%;
              transform: translate(0,-50%);
              content: "";
              border-left: 10px solid #C9E7FF;
              border-top: 8px solid transparent;
              border-bottom: 8px solid transparent;
          }
      }

        .warning {
            background: #409eff;
             &::after {
             position: absolute;
              border-left: 10px solid #409eff;
            }
          }


 
  
       
     .message-content{
          flex:1;
          text-align: left;
     }
     .message-content-self{
          flex:1;
          text-align: justify;
     }

     .list{
       width:100%;
       padding:20px;
       box-sizing: border-box;
     }

     .scroll-wrap{
       height:100%;
       position: relative;
     }

     .more-tip{
       text-align: center;
       color:#ccc;
       wdith:100%;
     }
      `,

        // 数据源
        data: {
          msgList: [],
          // tip: "加载更多...",
          tip: "没有更多数据了",
          scrollTop: 0,
          flag: true,//用于防抖
          totals: 0
        },

        // 方法
        methods: {
          /** 滚动到底部触发 */
          onScrollLower() {
            console.log("触底了", this.data.msgList);
            if (!(this.data.msgList.length >= that.pageInfo.totals)) {
              // if (this.data.flag) {
              //   that.instance.setData({
              //     flag: false
              //   })
              //   that.pageInfo.current++
              //   that.getDataList()
              // }
              // setTimeout(() => {
              //   that.instance.setData({
              //     flag: true
              //   })
              // }, 1000)
              that.pageInfo.current++
              that.getDataList()
            } else {
              that.instance.setData({
                tip: "没有更多数据了"
              })
            }
          },

          /** 失败触发 */
          onOpenMsgError(event) {
            // 用户在使用过程中，常见的异常状态为 “当前登录态过期”，此时需要服务商引导用户重新进行扫码登录。
            // “登录态异常”的出现时机有两个：
            // 初始化 openDataFrame 流程中，登录态已经失效；
            // 初始化成功后，长时间使用未重新登录，登录态已经失效；
            // 错误事件会在 createOpenDataFrame 的 error 回调中返回，有两种错误特征：
            // 浏览器判断登录过期后自动删除票据，特征为 errMsg 为 “Missing open sid”：
            // 后台判断登录态过期，特征为 errCode 为 42006：
            if (event && event.errCode === '42006' || event.errMsg === 'Missing open sid') {
              this.$message("登录状态失效，请重新登录")
            }
            // 使用过程，登录态失效出错,错误事件会在 ww-xxx 组件的 binderr 回调中返回，错误特征为：detail.errCode 为 42003 或者 40029：
            if (event && event.detail.errCode === '42003' || event.detail.errCode === '40029') {
              this.$message("登录态失效或出错，请重新登录")
            }
            console.warn('open message error: ', event);
          },
        },

        /** 视图挂载成功后的回调 */
        handleMounted() {
        },
        /** 视图更新成功后的回调 */
        handleUpdated() {
        }
      });
    },

    /** 消息类型改变，提供于父组件调用*/
    typeChange(type) {
      switch (type) {
        case "all":
          this.msgType = ""
          break;
        case "file":
          this.msgType = "8"
          break;
        case "image":
          this.msgType = "2"
          break;
        case "call":
          this.msgType = "6"
          break;
      }
      this.msgList = []
      this.instance.setData({
        msgList: this.msgList,
        scrollTop: 0
      })
      console.log("this.sendInfo.sendFrom", this.sendInfo.sendFrom);
      console.log("this.sendInfo.sendFrom", this.sendInfo.sendTo);
      if (this.sendInfo.sendFrom && this.sendInfo.sendTo) {
        this.pageInfo.current = 1;
        this.getDataList()
        that.$nextTick(async () => {
          let scrollViewContext = await createScrollViewContext(this.instance, 'scrollRef')
          scrollViewContext.scrollTo({ top: 0 })
        })
      }
    },

    /** 随着字串 */
    randomString(len) {
      len = len || 32;
      var $chars =
        "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678"; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
      var maxPos = $chars.length;
      var pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
  },

  watch: {
    // 监听外部好友变化
    idData: {
      handler(newVal, oldVal) {
        console.log("sdfsfsfs",newVal);
        this.msgType = ''
        this.pageInfo.totals = 0
        this.sendInfo.sendFrom = ""
        this.sendInfo.sendTo = ""
        this.msgList = []
        if (this.instance) {
          that.instance.setData({
            msgList: this.msgList,
            tip: ""
          })
        }
        if (newVal[0] && newVal[1]) {
          this.sendInfo.sendFrom = newVal[0]
          this.sendInfo.sendTo = newVal[1]
          this.pageInfo.current = 1;
          /** 必须调用后执行，签名会过期，目前过期后initOpenData函数会报错，代码无法往下执行，所以每次都必须调用一次获取数据的接口后在进行会话数据展示 */
          that = this;
          if (!this.instance) {
            getAgentConfig(localStorage.getItem("Authorization")).then(async () => {
              await this.registerInformation();
              // 这里必须用定时器延迟一下，不然可能会出现加载不出来的问题
              setTimeout(() => {
                that.getDataList();
              }, 500)
            })
          } else {
            that.$nextTick(async () => {
              await that.getDataList();
              let scrollViewContext = await createScrollViewContext(this.instance, 'scrollRef')
              scrollViewContext.scrollTo({ top: 0 })
            })
          }
        } else {
          this.msgList = []
          if (this.instance) {
            that.instance.setData({
              msgList: this.msgList,
              tip: ""
            })
          }
        }
      },
      deep: true,
    },

    // 监听tab切换
    //   type: {
    //   async handler(newVal, oldVal) {
    //     this.msgList = []
    //     this.instance.setData({
    //       msgList: this.msgList,
    //       scrollTop: 0
    //     })
    //     console.log("this.sendInfo.sendFrom", this.sendInfo.sendFrom);
    //     console.log("this.sendInfo.sendFrom", this.sendInfo.sendTo);
    //     if (this.sendInfo.sendFrom && this.sendInfo.sendTo) {
    //       this.pageInfo.current = 1;
    //       this.getDataList()
    //       that.$nextTick(async () => {
    //         let scrollViewContext = await createScrollViewContext(this.instance, 'scrollRef')
    //         scrollViewContext.scrollTo({ top: 0 })
    //       })
    //     }
    //   }
    // },

  },
  created() {
    console.log("Sdfsfsdfs",this.chatType);
  },
};
</script>
<style lang="scss" scoped>

#new-conversation-iframe-container {
  width: 100%;
  height: 100%;
}

::v-deep iframe {
  height: 100%;
  overflow: hidden;
  width: 100%;

}

.scroll-box {
  height: 100%;
  width: 100%;
  position: relative;

  .chat-complate {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    z-index: 999;
    .empty-text {
      line-height: 60px;
      width: 50%;
      color: #909399;
      text-align: center;
    }
  }
}


</style>
  